import React, { useEffect, useState } from 'react';
import { WEB_BUILDER_URL, TEMPLATE_CATEGORIES } from '../../fiesta.constants';
import './Admin.css';
import { fetchTemplates, publishTemplate } from '../../utils/templates.utils';

interface Template {
  id: string;
  name: string;
  category: string;
  isActive: boolean;
}

const Templates: React.FC = () => {
  const [templates, setTemplates] = useState<Template[]>([]);
  const [selectedCategory, setSelectedCategory] = useState<string>('all');
  const [selectedTemplate, setSelectedTemplate] = useState<Template | null>(null);
  const categories = [{ id: 'all', title: 'All' }, ...Object.values(TEMPLATE_CATEGORIES)];
  const filteredTemplates = templates.filter(template => {
    return selectedCategory === 'all' || template.category === selectedCategory;
  });

  useEffect(() => {
    fetchTemplates().then(setTemplates);
  }, []);

  useEffect(() => {
    if (!selectedTemplate) {
      setSelectedTemplate(templates[0]);
    }
  }, [selectedTemplate, templates]);

  return (
    <div className="templates-layout">
      <div className="templates-sidebar">
        <div className="category-dropdown">
          <select
            value={selectedCategory}
            onChange={e => setSelectedCategory(e.target.value)}
            className="category-select"
          >
            {Object.values(categories).map(category => (
              <option key={category.id} value={category.id}>
                {category.title}
              </option>
            ))}
          </select>
        </div>

        <div className="templates-list">
          {filteredTemplates.map(template => (
            <div
              key={template.id}
              className={`template-item ${selectedTemplate?.id === template.id ? 'selected' : ''}`}
              onClick={() => setSelectedTemplate(template)}
            >
              <div className="template-preview">
                <iframe
                  src={`${WEB_BUILDER_URL}/preview?websiteId=${template.id}&type=template&state=draft`}
                  title={`Preview ${template.name}`}
                  className="template-iframe"
                  scrolling="no"
                  style={{ width: '100%', height: '100%', border: 'none', pointerEvents: 'none' }}
                />
                <div className={`status-indicator ${template.isActive ? 'active' : 'inactive'}`}></div>
              </div>
              <div className="template-details">
                <h4>{template.name}</h4>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="templates-content">
        {selectedTemplate?.id && (
          <>
            <button
              className="primary-button"
              onClick={() => {
                window.open(
                  `${WEB_BUILDER_URL}/preview?websiteId=${selectedTemplate?.id}&type=template&state=draft`,
                  '_blank'
                );
              }}
            >
              Preview
            </button>
            <button
              className="primary-button"
              onClick={() => {
                if (window?.confirm('Are you sure you want to publish this template?')) {
                  publishTemplate(selectedTemplate?.id);
                }
              }}
              style={{ float: 'right' }}
            >
              Publish
            </button>
          </>
        )}

        <iframe
          src={`${WEB_BUILDER_URL}/web-builder?websiteId=${selectedTemplate?.id}&type=template&state=draft`}
          title="Web Builder"
          className="web-builder-iframe"
          frameBorder="0"
        />
      </div>
    </div>
  );
};

export default Templates;
